import { Card, pn, Stack, ValidationErrors } from "@compass/core";
import {
  StudentFilter as StudentFilterModel,
  ControlGroupStudentFilter as ControlGroupStudentFilterModel,
  StudentReportNscReportBy,
  StudentReportNscReportById,
  StudentReportNscRequest,
  StudentReportNscResource,
  StudentReportNscDisplay,
} from "generated/openApi";
import produce from "immer";
import { ControlGroupStudentFilter } from "pages/control-group-students/control-group-students/ControlGroupStudentFilter";
import { StudentFilter } from "pages/students/students/StudentFilter";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";
import { NscReportBy } from "./NscReportBy";
import { NscDisplay } from "./NscDisplay";

export const NscRequest = (props: {
  initialized: boolean;
  request: StudentReportNscRequest;
  setRequest: (value: StudentReportNscRequest) => void;
  validationErrors: ValidationErrors;
}) => {
  const [resource, setResource] = useState<StudentReportNscResource>({});

  useEffect(() => {
    if (props.initialized) {
      ApiService.studentReports.getNscRequest().then((response) => {
        props.setRequest(response);
      });

      ApiService.studentReports.getNscResource().then((response) => {
        setResource(response);
      });
    }
  }, [props.initialized]);

  return (
    <Stack spacing="lg">
      <NscReportBy
        reportBy={props.request.reportBy || ({} as StudentReportNscReportBy)}
        setReportBy={(reportBy) =>
          props.setRequest(
            produce(props.request, (draft) => {
              draft.reportBy = reportBy;
            })
          )
        }
        resource={resource.reportBy || {}}
        validationErrors={props.validationErrors[pn<StudentReportNscRequest>("reportBy")] || {}}
      />

      {props.request.reportBy?.reportById && (
        <>
          <Card header="Common Filter">
            {props.request.reportBy?.reportById === StudentReportNscReportById.Request && (
              <StudentFilter
                filter={props.request.studentFilter || ({} as StudentFilterModel)}
                setFilter={(studentFilter) =>
                  props.setRequest(
                    produce(props.request, (draft) => {
                      draft.studentFilter = studentFilter;
                    })
                  )
                }
              />
            )}

            {props.request.reportBy?.reportById === StudentReportNscReportById.ComparisonGroup && (
              <ControlGroupStudentFilter
                filter={props.request.controlGroupStudentFilter || ({} as ControlGroupStudentFilterModel)}
                setFilter={(controlGroupStudentFilter) =>
                  props.setRequest(
                    produce(props.request, (draft) => {
                      draft.controlGroupStudentFilter = controlGroupStudentFilter;
                    })
                  )
                }
              />
            )}
          </Card>

          <NscDisplay
            display={props.request.display || ({} as StudentReportNscDisplay)}
            setDisplay={(display) =>
              props.setRequest(
                produce(props.request, (draft) => {
                  draft.display = display;
                })
              )
            }
            validationErrors={props.validationErrors[pn<StudentReportNscRequest>("display")] || []}
          />
        </>
      )}
    </Stack>
  );
};
